export default function DefaultHelmet() {
  return (
    <>
      <meta charSet="UTF-8" />
      <link rel="icon" href="/favicon.ico" />
      <link rel="icon" type="image/png" href="/favicon.png" />
      <link
        rel="icon"
        type="image/png"
        sizes="48x48"
        href="/favicon-48x48.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="192x192"
        href="/favicon-192x192.png"
      />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1.0, interactive-widget=resizes-content"
      />
      <link rel="apple-touch-icon" href="/apple-touch-icon.png" />
      <link
        rel="apple-touch-icon"
        type="image/png"
        sizes="167x167"
        href="/favicon-167x167.png"
      />
      <link
        rel="apple-touch-icon"
        type="image/png"
        sizes="180x180"
        href="/favicon-180x180.png"
      />
      <title>aqora</title>
      <meta name="coverage" content="Worldwide" />
      <meta name="twitter:domain" content="aqora.io" />
      <meta name="twitter:creator" content="@aqora_quantum" />
      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Aqora" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="apple-mobile-web-app-title" content="Aqora" />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-touch-fullscreen" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="default" />
      <meta
        name="theme-color"
        media="(prefers-color-scheme: light)"
        content="#FCFCFD"
      />
      <meta
        name="theme-color"
        media="(prefers-color-scheme: dark)"
        content="#FCFCFD"
      />
    </>
  );
}
